import styled from "@emotion/styled";
import {Font} from "../theme/types";
import {getTheme} from "../utils";
import {
  FormProps,
  FormStyleFn,
  getFocusableColor,
  animatedFontStyle,
  disabledTextStyle,
} from "./utils";

const inverseErrorStyle: FormStyleFn<Font> = ({
  inverse,
  hasError,
  disabled,
  theme,
  crossBrand,
}) =>
  inverse &&
  hasError &&
  !disabled &&
  getTheme({theme, crossBrand}).font.secondary;

const Label = styled.label<FormProps>`
  position: absolute;
  transition: all 200ms ease;
  color: ${getFocusableColor("gray60")};
  ${animatedFontStyle}
  ${disabledTextStyle}
  ${inverseErrorStyle}
`;

export default Label;
